import SecurityFieldPage from '../pages/securityField/page'
import SecurityFieldSettingsPage from '../pages/securityField/settings/page'

export const securityFieldRoutes = [
  { path: '/security_field', element: <SecurityFieldPage /> },
  {
    path: '/security_field/settings/:securityFieldId',
    element: <SecurityFieldSettingsPage />,
  },
]
